const lang = {
  LT: {
    common: {
      ok: "Gerai",
      cancel: "Atšaukti",
      yes: "Taip",
      no: "Ne",
      submit: "Pateikti",
      close: "Uždaryti",
      dismiss: "Atmesti",
      error: "Klaida",
      warning: "Įspėjimas",
      caution: "Dėmesio",
      add: "Pridėti",
      create: "Sukurti",
      delete: "Ištrinti",
      edit: "Redaguoti",
      loading: "Kraunama...",
      searching: "Ieškoma...",
      preparing: "Ruošiama...",
      uploading: "Įkeliama...",
      processing: "Apdorojama...",
      being_replaced: "Perrašoma...",
      no_matches_found: "Nerasta atitikmenų",
      created_by: "Sukūrė",
      carried_out_by: "Atliko",
      search: "Ieškoti",
      no_access: "Vartotojas neturi priėjimo prie šių duomenų.",
      last_edit: "Paskutinį kartą keitė",
      today: "Šiandien",
      yesterday: "Vakar",
      clear: "Išvalyti",
      ac: "AC",
      bc: "BC (Ctrl)",
      delete_point: "Ištrinti tašką (Alt)",
      next: "Tęsti",
      back: "Atgal",
    },
    captions: {
      id: "ID",
      from_report: "Iš ataskaitos",
      iid: "Dalyvio kodas",
      code: "Kodas",
      comment: "Komentaras",
      description: "Aprašymas",
      diagnoses: "Diagnozės",
      given_name: "Vardas",
      family_name: "Pavardė",
      full_name: "Vardas Pavardė",
      email: "El. paštas",
      primary_email: "El. paštas",
      name: "Pavadinimas",
      roles: "Rolės",
      organisation_roles: "Rolės",
      level1: "Lygis 1",
      level2: "Lygis 2",
      level3: "Lygis 3",
      destination: "Paskirtis",
      aspect: "Aspektas",
      feature: "Ypatybė",
      age: "Amžius",
      gender: "Lytis",
      m: "V (vyras)",
      f: "M (moteris)",
      m_short: "V",
      f_short: "M",
      male_under_18: "V (vyras)",
      female_under_18: "M (moteris)",
      left: "Kairė",
      right: "Dešinė",
      back: "Galas",
      front: "Priekis",
      could_not_tell: "Nežino",
      correct: "Teisingai",
      error: "Klaida",
      owner: "Savininkas",
      year_born: "Gimimo metai",
      date_of_birth: "Gimimo data",
      change: "Keisti",
      delete: "Ištrinti",
      select_from_list: "Pasirinkti",
      notes: "Pastabos",
      no_options: "Nėra pasirinkimų",
      rename: "Pervadinti",
      date_created: "Sukurta",
      date_modified: "Redaguota",
      state: "Statusas",
      undo: "Anuliuoti",
      positive: "Teigiamas",
      negative: "Neigiamas",
      unassigned: "Nepriskirtas",
      probability: "Tikimybė",
      version: "Versija",
    },
    conclusions: {
      title: "Išvados",
      conclusions_loading: "Išvados kraunasi...",
      conclusion_loading: "Išvada kraunasi...",
      create: "Sukurti išvadą",
      edit_features_list: "Keisti ypatybių sąrašą",
      edit_conclusion: "Redaguoti išvadą",
      edit_rules: "Redaguoti taisykles",
      descriptions: "Išvados tekstas",
      rules: "Taisyklės",
      destination: "Išvados paskirtis",
      generic: "Bendras",
      neurological: "Neurologinis",
      physiological: "Fiziologinis",
      pedagogical: "Pedagoginis",
      psychological: "Psichologinis",
      generic_aspect: "Bendros išvados",
      neurological_aspect: "Neurologinės išvados",
      physiological_aspect: "Fiziologinės išvados",
      pedagogical_aspect: "Pedagoginiės išvados",
      psychological_aspect: "Psichologinės išvados",
      add_age_rule: "Pridėti amžiaus taisyklę",
      add_gender_rule: "Pridėti lyties taisyklę",
    },
    spectra: {
      title: "Pavyzdžiai",
      examples: "Pavyzdžiai",
      example: "Pavyzdys",
      example_loading: "Pavyzdys kraunasi...",
      spectra_loading: "Pavyzdžiai kraunasi...",
      empty_label: "Šioje grupėje pavyzdžių nėra",
      open_example: "Atidaryti pavyzdį",
      enlarge: "Padidinti",
      edit_features_list: "Keisti ypatybių sąrašą",
      edit_tags_list: "Keisti žymių sąrašą",
      edit_notes: "Keisti pastabas",
      edit_name: "Keisti pavadinimą",
      positive_examples: "Teigiami pavyzdžiai",
      negative_examples: "Neigiami pavyzdžiai",
      unassigned_examples: "Nepriskirti pavyzdžiai",
    },
    features: {
      title: "Ypatybės",
      features_loading: "Ypatybės kraunasi...",
      feature_loading: "Ypatybė kraunasi...",
      create: "Sukurti ypatybę",
      edit_feature: "Redaguoti ypatybę",
      edit_conclusions_list: "Keisti išvadų sąrašą",
      positive_features: "Tinkančios",
      negative_features: "Netinkančios",
      unassigned_features: "Nepriskirtos",
      edit_labels: "Keisti priskyrimus",
      stop_editing: "Baigti redagavimą",
      empty_label_group: "Tuščia",
      filter_features_placeholder: "Filtruoti pagal pavadinimą",
      show_more: "Rodyti daugiau",
    },
    test: {
      title: "Testavimas",
      new_test: "Naujas testas",
      ac_left_instructions: "Kairės ausies testavimas ausinėmis",
      ac_right_instructions: "Dešinės ausies testavimas ausinėmis",
      ac_left: "Kairės ausies testavimas ausinėmis",
      ac_right: "Dešinės ausies testavimas ausinėmis",
      bc_left_instructions: "Kairės ausies testavimas kaulo detektoriumi",
      bc_right_instructions: "Dešinės ausies testavimas kaulo detektoriumi",
      bc_left: "Kairės ausies testavimas kaulo detektoriumi",
      bc_right: "Dešinės ausies testavimas kaulo detektoriumi",
      selectivity: "Selectivity testas",
      selectivity_left: "Kairės ausies selectivity testas",
      selectivity_right: "Dešinės ausies selectivity testas",
      laterality: "Laterality testas",
      results: "Rezultatai",
      start: "Pradėti",
      quit: "Išeiti",
      skip: "Praleisti testą",
      next: "Toliau",
      next_test: "Sekantis testas",
      submit: "Siųsti rezultatus",
      did_not_hear: "Neišgirdo",
    },
    analyses: {
      title: "Analizės",
      analysis: "Ataskaita",
      feature_selection: "Pasirenkamos ypatybės",
      conclusion_selection: "Pasirenkamos išvados",
      finished: "Užbaigta",
    },
    reports: {
      title: "Ataskaitos",
      report: "Ataskaita",
      create: "Sukurti ataskaitą",
      select_profile: "Pasirinkti testo analizės profilį kuriamai ataskaitai.",
      profiles_loading: "Profiliai kraunasi...",
      generate_pdf: "Generuoti ataskaitą",
      generating: "Generuojama...",
      error: "Klaida",
      finished: "Užbaigta",
    },
    assessments: {
      title: "Testai",
      assessment_loading: "Testas kraunasi...",
      assessments_loading: "Testai kraunasi...",
      new: "Naujas testas",
      assessment_id: "Testo ID",
      assessment_date: "Atlikimo data",
      start_assessment: "Testuoti",
    },
    assessments_finished: {
      title: "Testai su ataskaitomis",
    },
    assessments_pending: {
      title: "Testai be ataskaitų",
    },
    participants: {
      title: "Testuojamieji",
      participant_loading: "Testuojamasis kraunasi...",
      participants_loading: "Testuojamieji kraunasi...",
      create: "Sukurti testuojamąjį",
      edit_participant: "Keisti testuojamojo informaciją",
    },
    diagnoses: {
      title: "Diagnozės",
    },
    users: {
      title: "Vartotojai",
      users_loading: "Vartotojai kraunasi...",
      create: "Sukurti vartotoją",
    },
    organisations: {
      title: "Organizacijos",
      organisation: "Organizacija",
      organisations_loading: "Organizacijos kraunasi...",
      organisation_loading: "Organizacija kraunasi...",
      create: "Sukurti Organizaciją",
    },
    staff: {
      title: "Darbuotojai",
      staff_loading: "Darbuotojai kraunasi...",
      create: "Sukurti darbuotoją",
    },
    tags: {
      title: "Žymės",
      create: "Sukurti žymę",
    },
    auth: {
      login: "Prisijungti",
      logout: "Atsijungti",
      username: "Vartotojo vardas",
      password: "Slaptažodis",
    },
    destination: {
      1: "1",
      2: "2 bendra",
      "2_r": "2 dešinė",
      "2_l": "2 kairė",
    },
    prognosis: {
      title: "Prognozė",
      loading: "Prognozės kraunasi...",
      no_active_model: "Modelis dar neapmokytas — prognozių nėra",
      empty_bucket: "Šioje grupėje pavyzdžių nėra",
      bucket_label: "Grupė",
      sort_label: "Rikiavimas",
      sort_probability: "Pagal tikimybę",
      sort_last_edit_at: "Pagal redagavimo datą",
      pending: "Laukiama",
      errored: "Klaidų",
      buckets: {
        true_positive: "Teisingai teigiama prognozė",
        false_positive: "Klaidingai teigiama prognozė",
        unassigned_positive: "Nepriskirta teigiama prognozė",
        true_negative: "Teisingai neigiama prognozė",
        false_negative: "Klaidingai neigiama prognozė",
        unassigned_negative: "Nepriskirta neigiama prognozė",
        pre_populated_negatives: "Nepatvirtinti neigiami pavyzdžiai",
      },
      inference_state: {
        pending: "Laukiama prognozės",
        errored: "Prognozės klaida",
        missing: "Nėra prognozės",
      },
    },
    model: {
      title: "Modelis",
      fall_back_to_previous_version: "Grąžinti ankstesnę versiją",
      evaluation_compared_to_previous:
        "Modelio įvertinimas lyginant su ankstesne versija",
      evaluation_at_training: "Treniravimo metu",
      evaluation_live: "Šiuo metu",
      previous_model: "Ankstesnis modelis",
      true_positive: "Teisingai teigiamas",
      false_negative: "Klaidingai neigiamas",
      false_positive: "Klaidingai teigiamas",
      true_negative: "Teisingai neigiamas",
      update_model: "Atnaujinti modelį",
      updating: "Modelis atnaujinamas...",
      training_failed: "Nepavyko atnaujinti modelio.",
      technical_details: "Techninė informacija",
      needs_positive_and_negative:
        "Modeliui apmokyti reikia bent vieno teigiamo ir bent vieno neigiamo pavyzdžio.",
      outdated_badge: "Neatnaujintas modelis",
      abnormal_training_set: "Per mažai pavyzdžių — įvertinimas nepatikimas",
      not_trained_yet: "Modelis dar neapmokytas",
      no_previous_version: "Ankstesnės versijos nėra",
      loading: "Modelio informacija kraunasi...",
    },
  },
};

const getTranslation = ({ translations, stringArray }) => {
  if (translations == null) return null;
  if (Array.isArray(stringArray)) {
    if (stringArray.length > 1) {
      return getTranslation({
        translations: translations[stringArray[0].toLocaleLowerCase()],
        stringArray: stringArray.slice(1),
      });
    } else if (stringArray.length === 1) {
      return translations[stringArray[0].toLocaleLowerCase()];
    } else {
      return null;
    }
  }
  return null;
};

const useLang = () => {
  const onTranslate = (textToTranslate) => {
    const textArray = textToTranslate.split(".");
    const idxOfUndefined = textArray.findIndex(
      (string) => string === "undefined"
    );
    if (idxOfUndefined > -1) return "-";
    if (typeof textToTranslate !== "string") return "";
    const result = getTranslation({
      translations: lang.LT,
      stringArray: textToTranslate.split("."),
    });
    if (result == null) return textToTranslate;
    return result;
  };
  return onTranslate;
};

export default useLang;
